import gso from '../data/brands/gso.json';
import apexNc from '../data/brands/apex-nc.json';
import apexTn from '../data/brands/apex-tn.json';

const brands = {
  'gso': gso,
  'apex-nc': apexNc,
  'apex-tn': apexTn,
};

const domainToBrand = {
  'gaspineortho.com': 'gso',
  'www.gaspineortho.com': 'gso',
  'apexosn.com': 'apex-nc',
  'www.apexosn.com': 'apex-nc',
  'apexosntn.com': 'apex-tn',
  'www.apexosntn.com': 'apex-tn',
};

/**
 * Resolve which brand config to use based on hostname.
 * Falls back to GSO for development / unknown hosts.
 */
export function resolveBrand(hostname) {
  // Build-time hard lock: if REACT_APP_BRAND was set during build,
  // honor it above all hostname/port heuristics. This prevents an Amplify
  // app from accidentally serving the wrong brand at an unrecognized host.
  const buildBrand = process.env.REACT_APP_BRAND;
  if (buildBrand && brands[buildBrand]) return brands[buildBrand];

  // Check direct domain match
  const brandKey = domainToBrand[hostname];
  if (brandKey && brands[brandKey]) return brands[brandKey];

  // Port-based brand detection (dev + test ports)
  // Test: :8081=GSO, :8082=Apex NC, :8083=Apex TN
  // Dev:  :3001=GSO, :3002=Apex NC, :3003=Apex TN
  if (hostname.includes(':8082') || hostname.includes(':3002')) return brands['apex-nc'];
  if (hostname.includes(':8083') || hostname.includes(':3003')) return brands['apex-tn'];
  if (hostname.includes(':8081') || hostname.includes(':3001')) return brands['gso'];

  // Check env override
  if (process.env.REACT_APP_BRAND && brands[process.env.REACT_APP_BRAND]) {
    return brands[process.env.REACT_APP_BRAND];
  }

  // Default: GSO
  return brands['gso'];
}

/**
 * Get all brand configs (for build-time SSG).
 */
export function getAllBrands() {
  return Object.values(brands);
}

/**
 * Get brand by key.
 */
export function getBrandByKey(key) {
  return brands[key] || null;
}

export default resolveBrand;
